import { useEffect, useState } from "react";
import { BasicButton } from "../../theme/Component/BasicButton";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { ListMenu } from "../../theme/Component/ListMenu";
import { toast } from "react-toastify";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { _RelationshipByOwner } from "../../../core/services/dataBean/EntityCatalogVdos";
import { AccountEditor } from "../../editor/AccountEditor";
import { RelationshipTypeEditor } from "../../Talentohumano/ParametrosTalentoHumano/RelationshipType/RelationshipTypeEditor";
import { RelationshipClassConstants } from "./RelationshipClassConstants";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";



interface Props {
    accountID: number;
}

export const RelationshipByOwner = ({ accountID }: Props) => {

    const rel = useDataBean(_RelationshipByOwner);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [Type, setType] = useState<any>(null)
    const [modalentity, setModalentity] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modaltype, setModaltype] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [accountID])

    const getLista = () => {

        rel.instance.getAccountRelationshipByOwner(accountID,Type).then(
            (resp: any) => {
                if (resp) {
                   let x = resp;
                    x.forEach((user) => {
                        user.DataBeanProperties.acc = (user.DataBeanProperties.AccountNit ?? "") + "-" + (user.DataBeanProperties.AccountName ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }

    const create = () => {
        rel.setBean({
            // IDAccount: accountID
            IDParent:accountID
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        rel.instance.deleteVoid(rel.bean.IDRelationship).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        rel.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    
    const head = [
        { title: 'ID', property: 'IDRelationship', visible: true },
        { title: 'Familiar', property: 'acc', visible: true },
        { title: 'Tipo de Relación', property: 'RelationshipTypeName', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Afiliación', property: 'Affiliate', visible: true },
        { title: 'Dependiente', property: 'Dependency', visible: true },
        { title: 'Dirección', property: 'Address', visible: true },
        { title: 'Teléfono', property: 'Telephone', visible: true },
        { title: 'Ocupación', property: 'Employment', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <label>Núcleo Familiar</label>
            <div className="col-md-6">
                <RelationshipClassConstants idSelector={Type} onChange={(e) => { setType(e) }}/>
            </div>
            <div className="col-md-2 mt-4 P-2">
                <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                    Buscar
                </BasicButton>
             </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={rel.setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <AccountEditor idAccount={rel.bean.IDAccount} label="Familiar" onChange={(e) => { rel.setBean({ ...rel.bean, 'IDAccount': e.IDAccount }) }} />
                        </div>
                         <div className="col-6">
                            <RelationshipTypeEditor render={rel.bean.RelationshipTypeName} idSelector={rel.bean.IDRelationshipType} onChange={(e) => { rel.setBean({ ...rel.bean, "IDRelationshipType": e.IDRelationshipType, "RelationshipTypeName": e.Name }) }} returnType="Object" />
                        </div>
                        <div className="col-md-6">
                            <RelationshipClassConstants idSelector={rel.bean.Type} onChange={(e) => { rel.setBean({ ...rel.bean, 'Type': e }) }}/>
                        </div>
                        <div className="col-md-6">
                            <label>Dirección</label>
                            <input type="text" name="Address" className="form-control" value={rel.bean.Address} onChange={(e: any) => { rel.setBean({ ...rel.bean, "Address": e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Teléfono</label>
                            <input type="text" name="Telephone" className="form-control" value={rel.bean.Telephone} onChange={(e: any) => { rel.setBean({ ...rel.bean, "Telephone": e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Ocupación</label>
                            <input type="text" name="Employment" className="form-control" value={rel.bean.Employment} onChange={(e: any) => { rel.setBean({ ...rel.bean, "Employment": e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                             <BasicSwitch label="Afiliación" estado={rel.bean.Affiliate} eventChange={(e) => { rel.setBean({ ...rel.bean, "Affiliate": e }) }} />
                        </div>
                        <div className="col-md-6">
                             <BasicSwitch label="Dependiente" estado={rel.bean.Dependency} eventChange={(e) => { rel.setBean({ ...rel.bean, "Dependency": e }) }} />
                        </div>
                    </div>
                </Modal>
                
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}